import QS from 'query-string';
import { DateTime } from 'luxon';

export const formattedDateFullYear = date => {
  if (!date) {
    return null;
  }
  return DateTime.fromISO(date.replace(' ', 'T')).toFormat("L'/'d'/'y");
};

export const getDateISOFromUrl = (timezone, location) => {
  if (location && location.search !== '') {
    const queryParams = QS.parse(location.search);
    // eslint-disable-next-line no-restricted-globals
    if (queryParams.date && !isNaN(Date.parse(queryParams.date))) {
      return DateTime.fromJSDate(new Date(queryParams.date)).setZone(timezone).startOf('day').toISO();
    }
  }
  return DateTime.local().setZone(timezone).startOf('day').toISO();
};

export const formatParsedDate = parsedDate => {
  if (!parsedDate || !parsedDate.isValid) {
    return null;
  }

  return parsedDate.toFormat('MMM d, yyyy');
};

/**
 * Tries to parse a given ISO date string
 * preserving the timezone in the datestring and returning null for invalid dates
 * @param {string} dateIso
 * @returns {DateTime|null}
 */
export const parseDatePreserveTimezone = dateIso => {
  if (!dateIso || typeof dateIso !== 'string') {
    return null;
  }
  const parsed = DateTime.fromISO(dateIso, { setZone: true });
  if (parsed.isValid) {
    return parsed;
  }
  return null;
};

export const standardizeISODate = (dateISO, year = true) => {
  if (!dateISO || !DateTime.fromISO(dateISO).isValid) {
    return null;
  }

  if (year) {
    return DateTime.fromISO(dateISO).toFormat('MMM d, yyyy');
  }
  return DateTime.fromISO(dateISO).toFormat('MMM d');
};

export const isSameMinute = (dateOne, dateTwo) => DateTime.fromISO(dateOne).hasSame(DateTime.fromISO(dateTwo), 'minute');

export const PTOAge = (PTOdate, timezone) => {
  try {
    const PTO = DateTime.fromISO(PTOdate).setZone(timezone);
    const now = DateTime.local().setZone(timezone);
    const { days } = now.diff(PTO, ['days']).toObject();
    if (!days) {
      return '';
    }
    // let's round this number because we only use it for mixpanel properties
    return Number(Math.ceil(days));
  } catch (e) {
    return '';
  }
};

export const getTimeZoneShort = timezone => {
  const TIMEZONE_SHORT = {
    'America/Los_Angeles': 'PST',
    'America/New_York': 'EST',
    'America/Chicago': 'CST',
    'America/Denver': 'MST',
    'America/Anchorage': 'AKST',
    'Pacific/Honolulu': 'HST',
  };
  if (!timezone) return '';
  return TIMEZONE_SHORT[timezone] || '';
};
